import { graphAtom } from "@features/run/RunGroupDialog/atoms"
import { RunGroupFormValues } from "@features/run/RunGroupDialog/RunGroupForm"
import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from "@mui/material"
import { getErrorMessage } from "@utils/form"
import { useAtomValue } from "jotai"
import { Controller, useFormContext } from "react-hook-form"

export const RunGroupFieldScenarios = () => {
  const graph = useAtomValue(graphAtom)
  const {
    control,
    formState: { errors },
  } = useFormContext<RunGroupFormValues>()

  if (!graph) return null

  return (
    graph.scenarios.length > 0 && (
      <Controller
        name="scenarios"
        control={control}
        render={({ field }) => (
          <FormControl variant="standard" error={Boolean(errors[field.name])}>
            <InputLabel>Scenarios</InputLabel>
            <Select multiple {...field}>
              {graph.scenarios.map((scenario) => (
                <MenuItem key={scenario} value={scenario}>
                  {scenario}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText error>{getErrorMessage(errors, field.name)}</FormHelperText>
          </FormControl>
        )}
      />
    )
  )
}
